module.exports = __webpack_public_path__ + "img/About_6.bc68047d.png";